// pro.rejouis.fr — questions fréquentes des boutiques (accordéon .faq de la charte).
import { Icons } from './components/ui.jsx';

// Vidéo de présentation du reconditionnement (Google Drive, partagée « tous les utilisateurs
// disposant du lien », sinon le lecteur demande une connexion Google).
const VIDEO_RECONDITIONNEMENT = 'https://drive.google.com/file/d/1MGjUzikDAPU2WpRROd0oEQyL5oNVRA_y/preview';
const PAGE_HYGIENE = 'https://rejouis.fr/pages/hygiene';

function Question({ titre, children, ouverte }) {
  return (
    <details className="faq" open={ouverte}>
      <summary>{titre}<Icons.chev size={18} /></summary>
      <div style={{ fontSize: 14.5, lineHeight: 1.65, color: 'var(--encre-doux)', padding: '0 2px 18px' }}>{children}</div>
    </details>
  );
}

export default function Faq({ retrocom, taux, commandes = true }) {
  return (
    <section style={{ marginTop: 34 }}>
      <h2 className="t-display" style={{ fontSize: 20, margin: '0 0 4px' }}>Questions fréquentes</h2>
      <div className="card" style={{ padding: '4px 18px', marginTop: 10 }}>
        <Question titre="Comment sont reconditionnés les jouets ?" ouverte>
          <p style={{ margin: '0 0 12px' }}>
            Chaque jouet passe par notre atelier : diagnostic de son fonctionnement et de sa batterie, lavage,
            désinfection aux UV-C, puis contrôle avant sa remise en vente. La vidéo présente l’ensemble du parcours.
          </p>
          {/* Vidéo verticale (9:16) : cadre au même format, centré et limité en largeur. */}
          <div style={{ maxWidth: 300, margin: '0 auto' }}>
            <div style={{ position: 'relative', paddingTop: '177.78%', borderRadius: 14, overflow: 'hidden', background: 'var(--stone-pale)' }}>
              <iframe src={VIDEO_RECONDITIONNEMENT} title="Le reconditionnement des jouets chez Rejouis" loading="lazy"
                allow="autoplay; fullscreen"
                style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }} />
            </div>
          </div>
          <p style={{ margin: '12px 0 0' }}>
            Tout le détail de notre protocole est sur notre{' '}
            <a href={PAGE_HYGIENE} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--rouge)', fontWeight: 600 }}>page hygiène</a>.
          </p>
        </Question>
        <Question titre="Comment vous envoyer des jouets ?">
          Cliquez sur « Déclarer un envoi » : indiquez le nombre de jouets et de cartons, ajoutez une photo du lot et
          dites-nous s’ils ont été testés. Vous obtenez un QR code Mondial Relay par carton, à présenter dans n’importe
          quel point relais : il imprime l’étiquette pour vous.
        </Question>
        <Question titre="Que deviennent les jouets que je vous envoie ?">
          Nous les recomptons à l’arrivée, puis ils passent par l’atelier. Ceux qui peuvent l’être sont reconditionnés
          et revendus. Vous suivez, envoi par envoi, combien ont été reconditionnés et combien ont trouvé preneur,
          avec un mot de l’atelier quand il y a quelque chose à signaler.
        </Question>
        {commandes ? (
          <Question titre="Comment se passe une commande ?">
            Choisissez des quantités par catégorie : nous composons le lot pour vous parmi nos jouets reconditionnés.
            Il n’y a rien à payer en ligne : nous préparons la commande et vous envoyons la facture. Le port est offert
            dès 300 € d’articles ; en dessous, il est calculé selon le poids, livraison Chronopost à la boutique.
          </Question>
        ) : null}
        {retrocom ? (
          <Question titre="Comment fonctionne mon bon d’achat ?">
            <p style={{ margin: '0 0 10px' }}>
              Chaque fois que nous revendons un jouet que vous nous avez envoyé, vous gagnez un pourcentage de son prix de vente
              en bon d’achat, crédité automatiquement chaque lundi.
            </p>
            <p style={{ margin: '0 0 10px' }}>
              Ce pourcentage dépend de la qualité de chaque lot, c’est-à-dire de la part de jouets que nous avons pu reconditionner
              sur ceux reçus : de 5 % pour un lot où peu de jouets sont réutilisables, jusqu’à 15 % pour un lot impeccable.
              Trier vos jouets avant envoi est donc doublement gagnant. Tant qu’un lot est en cours de reconditionnement, c’est le
              taux de vos lots précédents qui s’applique (aujourd’hui {Math.round((taux || 0.1) * 100)} %).
            </p>
            <p style={{ margin: 0 }}>
              Le détail est dans « Votre bon d’achat ». Au moment de commander, cochez « Utiliser mon bon d’achat sur cette
              commande » : le montant est retiré du total.
            </p>
          </Question>
        ) : null}
        <Question titre="Une autre question ?">
          Écrivez-nous en répondant à l’un de nos e-mails ou contactez directement votre interlocuteur Rejouis.
        </Question>
      </div>
    </section>
  );
}
